export const STORE_ADDRESS = "Rua Wenceslau Veiga, 01, Valéria, Salvador - BA";
export const STORE_HOURS = "segunda a sexta das 8h às 18h e sábado das 8h às 12h";

export function waPhone(phone) {
  const d = (phone || "").replace(/\D/g, "");
  return d.startsWith("55") && d.length >= 12 ? d : `55${d}`;
}

export const pickupDate = (order) => {
  const h = [...(order.status_history || [])].reverse().find((x) => x.status === "Disponível para retirada");
  const at = order.pickup_at || h?.at;
  return at ? new Date(at).toLocaleDateString("pt-BR") : "";
};

export const daysWaiting = (order) => {
  const at = order.pickup_at;
  return at ? Math.floor((Date.now() - new Date(at).getTime()) / 86400000) : 0;
};

export function pickupMessage(order, template) {
  const first = (order.customer?.name || "").split(" ")[0];
  return (template || "")
    .replaceAll("{nome}", first)
    .replaceAll("{pedido}", order.number || "")
    .replaceAll("{endereco}", STORE_ADDRESS)
    .replaceAll("{horario}", STORE_HOURS)
    .replaceAll("{data}", pickupDate(order));
}

export const waLink = (order, template) =>
  `https://wa.me/${waPhone(order.customer?.phone)}?text=${encodeURIComponent(pickupMessage(order, template))}`;
